import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const TableSettingsV1 = z.object({
  altRowBackgroundColor: z.string(),
  iconWidth: z.number().int(),
  rows: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
  ]),
  blur: z.union([z.literal(true), z.literal(false)]),
})

export type TTableSettingsV1 = z.infer<typeof TableSettingsV1>

export const TableElementV1 = z.object({
  id: z.string(),
  name: z.literal("table"),
  settings: TableSettingsV1,
  container: ContainerOptionsV1,
})

export type TTableElementV1 = z.infer<typeof TableElementV1>

// Latest ---------------------
export const TableSettings = TableSettingsV1
export type TTableSettings = TTableSettingsV1
export const TableElement = TableElementV1
export type TTableElement = TTableElementV1
